// Campus photo for /colleges/pace-university: CC BY 4.0, by ajay_suresh, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3APace_University_-_1_Pace_Plaza_(55314071109).jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/pace-university/; credited under the photo.
const photo = {
    "slug": "pace-university",
    "alt": "The entrance plaza of 1 Pace Plaza, Pace University's main building in Lower Manhattan, New York City",
    "src": "/colleges/pace-university/campus-1600.webp",
    "srcSmall": "/colleges/pace-university/campus-800.webp",
    "srcMid": "/colleges/pace-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/pace-university/og.jpg",
    "title": "Pace University - 1 Pace Plaza (55314071109)",
    "author": "ajay_suresh",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3APace_University_-_1_Pace_Plaza_(55314071109).jpg",
    "read": "2026-10-02"
};

export default photo;
